import { Button } from '@arco-design/web-react';
import { IconCheck, IconClose } from '@arco-design/web-react/icon';
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import styled from 'styled-components';

export interface ExpandableCardProps {
  /** 受控状态 */
  isOpen: boolean;
  /** 确认的回调 */
  onOk: () => void;
  /** 取消的回调 */
  onCancel?: () => void;
  /** 浮动卡片的内容 */
  content?: React.ReactNode;
  /** 定位的区域 */
  children?: React.ReactNode;
  /** 浮动卡片额外的样式 */
  style?: React.CSSProperties;
}

export function FloatExpandableCard({
  children,
  content,
  isOpen,
  onOk,
  onCancel,
  style,
}: ExpandableCardProps) {
  return (
    <Container>
      {children}
      <AnimatePresence>
        {isOpen && (
          <Card
            initial={{ opacity: 0, y: 0 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.05 }}
            style={style}
          >
            {content}
            <ButtonContainer>
              <Button style={{ width: 80 }} size="mini" onClick={onCancel} icon={<IconClose />} />
              <Button
                style={{ width: 80 }}
                size="mini"
                type="primary"
                onClick={onOk}
                icon={<IconCheck />}
              />
            </ButtonContainer>
          </Card>
        )}
      </AnimatePresence>
    </Container>
  );
}

/** ============================ 样式 ==================================== */
const Container = styled.div`
  position: relative;
`;

const Card = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: white;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  overflow: hidden;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 8px;
  gap: 8px;
  border-top: 1px solid #f0f0f0;
`;
